module.exports = __webpack_public_path__ + "static/media/vert03.d8f78831.glsl";